module.exports = __webpack_public_path__ + "media/alarm.ac93cdf2.mp3";